import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { THIS_MONTH } from '@host-panel/analytics/models/period';

import {
  DataPeriod,
  MonetizationState,
  SetMonetizationDataPayload,
  SortDirs
} from './monetizationTypes';

const initialState: MonetizationState = {
  data: [],
  summary: {
    publisherRevenue: 0,
    fillRate: 100
  },
  pageInfo: {
    device: 'all',
    source: 'all',
    fromDay: undefined,
    toDay: undefined,
    period: THIS_MONTH
  },
  sortDirs: {},
  isLoading: false
};

const monetizationSlice = createSlice({
  name: 'monetization',
  initialState,
  reducers: {
    setIsLoading(state, action) {
      state.isLoading = action.payload;
    },
    fetchMonetizationSuccess(state, action: PayloadAction<SetMonetizationDataPayload>) {
      const { data, summary, pageInfo } = action.payload;

      state.data = data;
      state.summary = summary;
      state.pageInfo = pageInfo;
      state.isLoading = false;
      state.sortDirs = {};
    },
    fetchMonetizationFailed(state, action: PayloadAction<DataPeriod>) {
      const { fromDay, toDay } = action.payload;

      state.isLoading = false;

      state.pageInfo.fromDay = fromDay;
      state.pageInfo.toDay = toDay;
    },
    setErrorMessage(state, action: PayloadAction<string>) {
      state.errorMessage = action.payload;
    },
    setSortDirs(state, action: PayloadAction<SortDirs>) {
      state.sortDirs = action.payload;
    }
  }
});

export const monetizationReducer = monetizationSlice.reducer;

export const {
  setIsLoading,
  fetchMonetizationSuccess,
  fetchMonetizationFailed,
  setErrorMessage,
  setSortDirs
} = monetizationSlice.actions;
